<template>
    <div class="row mb-5" Id="SalesOrders">
        <div class="col-12">
            <div class="pt-3 row">
                <form @submit.prevent='findItem' class="pt-3">
                    <label for="input-sku" class="form-label">
                    Enter SKU
                    </label>
                    <!-- <input ref='skuInput' type="text" v-model="sku" name='scannedSku' class="form-control" id="input-sku-to-pick"> -->
                    <input ref='skuInput' type="text" name='scannedSku' class="form-control" id="input-sku-to-pick"
                        placeholder="Filter by sku or order" @keyup='findItem'
                        v-model="filter" />
                </form>
            </div>
            <div class='row error-msg' v-if="scanError != ''">
                <div class='col-12 text-left'><span class='scanError'>{{scanError}}</span></div>
            </div>
            <div class='row OrderRow' v-for="(order, index) in filteredOrders" :key="`order-${index}`" >
            <!--<div class='row OrderRow' v-for='(order, index) in salesOrders' >-->
                <div class='col-12'>
                    <div class='row divider'>
                        <div class='col-12'>
                            <h3>Items in Order: <span v-html="highlightMatches(order.name)"></span></h3>
                        </div>
                    </div>
                    <div class='row purchase' v-if="order.purchaseNo != null">
                        <div class='col-12'>
                            <h3>PO#: <span v-html="highlightMatches(order.purchaseNo)"></span></h3>
                        </div>
                    </div>
                    <div class="itemRow" v-for="(item, index) in order.orderItems" :key='index'>
                        <ScannedItem
                            :sku='item.sku'
                            :upc='item.UPC'
                            :imgsrc='item.img'
                            :desc='item.description'
                            :position='index'
                            :picked='item.selected'
                            :bin='item.bin'
                            :offer='item.offerName'
                            :storeno='item.storeNum'
                            :ponum='item.purchaseNo'
                            :ordernum='item.orderNum'
                        />
                    </div> 
                </div>
            </div>
            <div class="row OutsideOrderRow" v-if="outOfOrderError">
                <div class='col-12'>
                    <div class='row divider OrderError'>
                        <div class='col-12 text-center'>
                            <h3 class='scanError' v-if='!outsideOrderFound && !unpickedSku'>ALERT: Selected SKU is not on an active Sales Order</h3>
                            <h3 class='scanError' v-if='outsideOrderFound && noOrderFound'>ALERT: Selected SKU is on an offer - {{itemOffer}} but does NOT appear on an active Sales Order</h3>
                            <h3 class='scanError' v-if='outsideOrderFound && !noOrderFound'>ALERT: Selected SKU is on unselected Sales Order <a :href='orderLink' target='_blank'>{{missingOrder}}</a></h3>
                            <h3 class='scanError' v-if='unpickedSku'>ALERT: Selected SKU is not picked from Sales Order <a :href='orderLink' target='_blank'>{{missingOrder}}</a></h3>
                        </div>
                    </div>
                    <div class="itemRow" v-for="(item, index) in outOfOrderItem" :key='index'>
                        <ScannedItem
                            :sku='item.SKU__c'
                            :upc='item.UPC__c'
                            :imgsrc='item.Image_URL__c'
                            :desc='item.Description__c'
                            :position='index'
                            :picked='item.selected'
                            :bin='missingOrderBin'
                            :storeno='item.storeNum'
                            :ponum='item.purchaseNo'
                            :ordernum='item.orderNum'

                        />
                    </div> 
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ScannedItem from './ScannedItem'
export default {
    name: 'SalesOrders',
    components:{
        ScannedItem
    },
    data() {
      return {
        filter:'',
        itemsScanned: this.$store.getters["ProductCollection/scannedCollection"], 
        //ordersInPick: this.$store.getters['PowerScan/ordersInPick'] || [],
        ordersInPick: this.$store.getters['ProductCollection/ordersToPick'] || [],

        selectedItems:[],
        unpickDisabled: this.listEmpty,
        salesOrders: [],
        sku: '',
        scanError: '',
        outOfOrderError: false,
        outOfOrderItem:{},
        outsideOrderFound:false,
        noOrderFound:false,
        itemOffer: '',
        unpickedSku:false,
        missingOrder:'',
        missingOrderBin:'',
        orderLink: '#',
        recentOrders: []

      }
    },
    computed:{
        listEmpty(){
            return this.selectedItems.length == 0 ? true : false
        },
        filteredOrders(){
            const searchTerm = this.filter.toLowerCase();
            return this.salesOrders.reduce((filtered, salesOrder) => {
                // Pushing entire section if we find needle in section title
                const purchaseNo = salesOrder.purchaseNo == null ? '' : salesOrder.purchaseNo.toLowerCase();
                
                if ((salesOrder.name.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0) ||
                    (purchaseNo.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0)){
                    filtered.push({ ...salesOrder })
                } else {
                    // Pushing section with filtered questions when question title match
                    const orderItems = salesOrder.orderItems.filter(orderItem => {
                    //orderItem.sku.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0
                        const itemSku = orderItem.sku.toString().toLowerCase();
                        const itemDesc = orderItem.description.toString().toLowerCase();
                        const upc = orderItem.UPC.toString().toLowerCase();
                        return itemSku.includes(searchTerm) ||
                                itemDesc.includes(searchTerm)||
                                upc.includes(searchTerm)
                    })
                    if (orderItems.length > 0) {
                    filtered.push({ ...salesOrder, orderItems })
                    }
                }
                return filtered
            }, [])
        }
        
    },
    mounted(){
       // console.log('salesOrder - mounted')
        this.getRecentOrders();
    },
    methods:{
        getItemsInOrder(){
            //console.log("called getItems in order")
            let orderList = this.ordersInPick;
            let currentOrderList = [];
            orderList.forEach((order) =>{
                //console.log('order: ', order);
                let products = this.$store.dispatch('PowerScan/fetchOrderItems', order)
                    .then((response) => {
                        //.log('item list - ', response)
                        currentOrderList.push(response);
                    });
            });
            this.salesOrders = currentOrderList;

        },
        highlightMatches(text) {
            const matchExists = text.toLowerCase().includes(this.filter.toLowerCase());
                if (!matchExists) return text;
                const re = new RegExp(this.filter, 'ig');
                    return text.replace(re, matchedText => `<strong>${matchedText}</strong>`);
        },
        async getRecentOrders(){
           // console.log('recent orders called');
            let orderList = [] //this.ordersInPick;
            
            let currentRecentOrders = await this.$store.dispatch('PowerScan/fetchRecentOrders')
                currentRecentOrders.forEach(order=>{
                    orderList.push(order);
                });
                this.salesOrders = orderList;
                //this.checkSavedOrders();
                //this.getItemsInOrder();
            //})
        },
        async checkSavedOrders(){
            return await new Promise((resolve, reject)=>{
                let savedOrderList = this.salesOrders;
                this.ordersInPick.forEach((order) =>{
                    if(savedOrderList.findIndex(x => x.name == order.name) == -1){
                        let products = this.$store.dispatch('PowerScan/fetchOrderItems', order)
                        .then((response) => {
                            order.orderItems = response;
                            savedOrderList.push(order);
                        });
                    }
                });
                this.ordersInPick = savedOrderList;
            });
        },
        async findItem(e){
            this.outOfOrderError = false;
            this.outsideOrderFound = false;
            this.unpickedSku = false;
            this.noOrderFound = false;
            this.missingOrder = '';
            this.missingOrderBin = '';
            this.scanError = '';
            this.itemOffer = '';
            let enter = ( 'Enter' == e.key ? '' : '' )
            if ( 'Enter' == e.key ) {
                e.preventDefault()
                //console.log('Enter pressed - sku: ', {sku: this.filter, store: 'PowerScan'});
                let searchItem = await this.$store.dispatch('ItemCard/fetchSimpleItemInfo', {sku: this.filter, store: 'PowerScan'})
                .then(response => {
                    //console.log('item found? - ', response);
                    this.outOfOrderError = true;
                    this.outOfOrderItem = response;
                    let orderInfo = this.$store.dispatch('ItemCard/fetchOfferInventoryData', this.filter)
                    .then(response =>{
                        //console.log('order info - ', response);
                        if(response.orders.length == 0){
                            this.outsideOrderFound = true;
                            this.noOrderFound = true;
                            this.itemOffer = response.offer;
                        }else{
                            this.orderLink= 'https://wgaca--rstk.visualforce.com//apex/SalesOrderWorkbench?div=aATf4000000GnHmGAK&ordno='+ response.orders[0].order_number
                            if(this.ordersInPick.findIndex(x => x.name == response.orders[0].order_number) == -1){
                                this.outsideOrderFound = true;
                                this.missingOrder = response.orders[0].order_number;
                            }else{
                                this.outsideOrderFound = false;
                                if(response.orders[0].qty_ordered > response.orders[0].qty_picked){
                                    this.unpickedSku = true;
                                    this.missingOrder = response.orders[0].order_number;
                                }else{
                                    this.scanError = 'unknown Error'
                                }
                            }
                        }
                        
                        this.missingOrderBin = response.bin;
                    }, error =>{
                        console.log('error - ', error)
                        //this.scanError = error;
                    });

                }, error => {
                    console.log("Got nothing from server.  try again - ", error)
                    this.scanError = error;
                })
                
            }
        }
    }
}
</script>